import PDFDocument from 'pdfkit/js/pdfkit.standalone.js';
import { COLOR_BLACK, FONT, FONT_BOLD, FONT_SIZE_LARGE, FONT_SIZE_NORMAL, FONT_SIZE_SMALL } from '../variables';
import { cmToPoint } from './units';

export function renderTitle(pdf: PDFDocument, body: any) {
	const space = 2;
	const hasStatus = !!body.status?.text;

	pdf.y += cmToPoint(1.45);

	pdf.font(FONT_BOLD).fontSize(FONT_SIZE_LARGE).fillColor(COLOR_BLACK);

	pdf.text(body.title, { continued: true }).font(FONT).text(` ${body.reference}`, { continued: hasStatus });

	if (hasStatus) {
		pdf.text(` - `, { continued: true });
		pdf.fillColor(body.status.color || COLOR_BLACK);
		pdf.text(body.status.text);
		pdf.fillColor(COLOR_BLACK);
	}

	pdf.fontSize(FONT_SIZE_NORMAL).font(FONT);

	if (body.subtitle) {
		pdf.y += space;
		pdf.text(body.subtitle);
	}

	if (body.description) {
		pdf.y += space;
		pdf.fontSize(FONT_SIZE_SMALL).text(body.description);
	}
}
